// src/services/loan.service.js
import apiClient from './api.service';

class LoanService {
  async getUserLoans(userId) {
    const response = await apiClient.get(`/loans/user/${userId}`);
    return response.data;
  }

  async createLoan(userId, loanData) {
    const response = await apiClient.post(`/loans/user/${userId}`, {
      borrowerName: loanData.borrower || loanData.borrowerName,
      loanAmount: parseFloat(loanData.amount || loanData.loanAmount),
      interestRate: parseFloat(loanData.interestRate || 0),
      dueDate: loanData.dueDate,
      notes: loanData.notes || ''
    });
    return response.data;
  }

  async updateLoan(loanId, userId, loanData) {
    const response = await apiClient.put(`/loans/${loanId}/user/${userId}`, {
      borrowerName: loanData.borrower || loanData.borrowerName,
      loanAmount: parseFloat(loanData.amount || loanData.loanAmount),
      interestRate: parseFloat(loanData.interestRate || 0),
      dueDate: loanData.dueDate,
      notes: loanData.notes || ''
    });
    return response.data;
  }

  async deleteLoan(loanId, userId) {
    const response = await apiClient.delete(`/loans/${loanId}/user/${userId}`);
    return response.data;
  }

  async repayLoan(loanId, userId, repaymentData) {
    // Calculate new loan amount after repayment
    const newAmount = parseFloat(repaymentData.currentAmount) - parseFloat(repaymentData.repaymentAmount);
    
    return this.updateLoan(loanId, userId, {
      borrowerName: repaymentData.borrowerName,
      loanAmount: newAmount,
      interestRate: repaymentData.interestRate,
      dueDate: repaymentData.dueDate,
      notes: repaymentData.notes || 'Reduced loan amount after partial payment'
    });
  }
}
const loanService = new LoanService();
export default loanService;